/**
 * Generate a simple UUID v4-like string
 * This is a browser-compatible alternative to Node.js crypto.randomUUID()
 */
export const generateUUID = (): string => {
  // Use crypto.randomUUID if available (modern browsers)
  if (typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }

  // Fallback for older browsers or test environments
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (8 + (r % 4));
    return v.toString(16);
  });
};

export const randomUUID = generateUUID;
